if (!customElements.get('gg-hat-bundle')) {
  customElements.define('gg-hat-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.message = this.querySelector('[data-message]');
      this.busy = false;
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100);
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-bundle-ui]').hidden = false;
      this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => this.showPhoto(button.dataset.thumb)));
      this.querySelectorAll('[data-color-variant]').forEach(button => button.addEventListener('click', () => {
        const select=this.querySelector('[data-tier="'+this.quantity()+'"] [data-slot]');
        select.value=button.dataset.colorVariant;
        this.update();
        this.showColor(this.variant(select.value));
      }));
      this.querySelectorAll('[data-slot]').forEach(select => select.addEventListener('change', () => { this.update(); this.showColor(this.variant(select.value)); }));
      this.querySelectorAll('[name="gg_bundle_size"]').forEach(radio => radio.addEventListener('change', () => { this.update(); this.showColor(this.selected()[0]); }));
      this.form.addEventListener('submit', event => this.add(event));
      this.update();
      this.showColor(this.selected()[0]);
    }
    variant(id) { return this.variants.find(variant => String(variant.id) === String(id)); }
    selected() { return Array.from(this.querySelector('[data-tier="'+this.quantity()+'"] .ggb__picks').querySelectorAll('[data-slot]')).map(select => this.variant(select.value)); }
    quantity() { return Number(this.querySelector('[name="gg_bundle_size"]:checked').value); }
    saving(quantity) { return quantity === 2 ? Number(this.dataset.saveTwo) : quantity === 3 ? Number(this.dataset.saveThree) : 0; }
    update() {
      const quantity = this.quantity();
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const count = Number(tier.dataset.tier);
        tier.querySelector('.ggb__picks').hidden = count !== quantity;
        const chosen = Array.from(tier.querySelectorAll('[data-slot]')).map(select => this.variant(select.value));
        const subtotal = chosen.reduce((sum,variant) => sum + (variant ? variant.price : 0),0);
        const compare = chosen.reduce((sum,variant) => sum + (variant ? Math.max(variant.price,variant.compare_at_price || 0) : 0),0);
        tier.querySelector('[data-tier-total]').textContent = this.money(Math.max(0,subtotal-this.saving(count)));
        tier.querySelector('[data-tier-compare]').textContent = this.money(compare);
        tier.querySelectorAll('[data-slot]').forEach(select => {
          const variant = this.variant(select.value);
          const image = select.closest('.ggb__pick').querySelector('img');
          if (variant && variant.featured_image) image.src = variant.featured_image.src;
        });
        if (count === quantity) this.querySelector('[data-total]').textContent = this.money(Math.max(0,subtotal-this.saving(count)));
      });
      const available = this.selected().every(variant => variant && variant.available);
      this.button.disabled = this.busy || !available;
      this.querySelector('[data-add-label]').textContent = available ? this.labels.add : this.labels.soldOut;
      this.querySelector('[data-fallback] select').value = this.selected()[0]?.id || '';
      const first=this.selected()[0];
      this.querySelectorAll('[data-color-variant]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.colorVariant === String(first?.id))));
      const colorLabel=this.querySelector('[data-color-label]');
      if (colorLabel && first) colorLabel.textContent=first.title;
    }
    showPhoto(id) {
      this.querySelectorAll('[data-photo]').forEach(photo => { photo.hidden = photo.dataset.photo !== String(id); });
      this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.thumb === String(id))));
    }
    showColor(variant) {
      if (!variant) return;
      const color = variant.option1;
      this.querySelectorAll('[data-thumb]').forEach(button => { button.hidden = !button.dataset.alt.includes(' - '+color+' - '); });
      const imageId = variant.featured_image?.id;
      const photo = imageId && this.querySelector('[data-photo="'+imageId+'"]');
      const first = this.querySelector('[data-thumb]:not([hidden])');
      if (photo) this.showPhoto(imageId); else if (first) this.showPhoto(first.dataset.thumb);
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.querySelector('[data-add-label]').textContent = this.labels.adding;
      this.message.textContent = '';
      const items = [];
      this.selected().forEach(variant => {
        const item = items.find(item => item.id === variant.id);
        if (item) item.quantity += 1; else items.push({id:variant.id,quantity:1});
      });
      try {
        const root = this.dataset.root || '/';
        const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.labels.error);
        window.location.assign(root+'cart');
      } catch (error) {
        this.message.textContent = error.message === 'Failed to fetch' ? this.labels.network : error.message || this.labels.error;
        this.busy = false;
        this.update();
      }
    }
  });
}
